var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-5/6 md:w-1/2 xl:w-1/3 mx-auto flex flex-col justify-center items-center content-center h-full"},[_c('img',{staticClass:"m-2",attrs:{"src":"/img/undraw_problem_solving.svg"}}),_c('div',{staticClass:"w-4/5"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }